import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common'
import contracts from './modules/contracts'
import auth from './modules/auth';
import users from './modules/users';
import parameterlayers from './modules/parameterlayers';
import parameters from './modules/parameters';
import domains from './modules/domains';
import presets from './modules/presets';
import reanalys from './modules/reanalys';
import forecasts from './modules/forecasts';
import billing from './modules/billing';
import predictranges from './modules/predictranges';
import radars from './modules/radars';
import forecastlong from './modules/forecastlong';
import geomap from './modules/geomap.js';
import geomapcontracts from './modules/geomapcontracts.js';
import synopcontracts from './modules/synopcontracts.js';
import synop from './modules/synop.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    contracts,
    auth,
    parameterlayers,
    parameters,
    domains,
    users,
    presets,
    reanalys,
    forecasts,
    billing,
    predictranges,
    radars,
    forecastlong,
    geomap,
    geomapcontracts,
    synopcontracts,
    synop
  }
});